export function Ico84Check() {
  return (
    <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="42" cy="42" r="42" fill="#ECF6FF" />
      <path d="M27 42L36.9882 52L57 32" stroke="#0087E0" strokeWidth="8" strokeLinecap="square" />
    </svg>
  );
}
